app.controller("AgreementWindowController", ["$scope", "$uibModalInstance", "params",
    function ($scope, $uibModalInstance, params) {
        $scope.agreement = params.agreement;
        $scope.title = params.agreement.title;
        $scope.text = params.agreement.text;
        $scope.actionText = params.agreement.actionText;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
